import { useEffect, useMemo, useState } from 'react';
import { Location } from 'core/contexts/locations/location.model';
import { mapLocationIds } from '../settings-devices-predefined-comments-form.mapper';
import { PredefinedCommentDeviceTypeEntry } from '../settings-devices-predefined-comments-form.model';
import { usePredefinedCommentFormContext } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/hooks/use-predefined-comment-form-context.hook';

interface UseLocationInitializerProps {
    entry: PredefinedCommentDeviceTypeEntry;
    locations: Location[];
    onChangeEntry: <K extends keyof PredefinedCommentDeviceTypeEntry>(
        entryId: string,
        field: K,
        value: PredefinedCommentDeviceTypeEntry[K]
    ) => void;
}

export const useLocationInitializer = ({ entry, locations, onChangeEntry }: UseLocationInitializerProps) => {
    const { mode } = usePredefinedCommentFormContext();
    const allLocationIds = useMemo(() => mapLocationIds(locations), [locations]);
    const [localLocations, setLocalLocations] = useState<string[]>(() =>
        mode === 'add' ? allLocationIds : entry.locations
    );

    useEffect(() => {
        if (mode === 'add') {
            onChangeEntry(entry.id, 'locations', allLocationIds);
            setLocalLocations(allLocationIds);
        } else if (mode === 'edit') {
            setLocalLocations(entry.locations);
        }
    }, [allLocationIds]);

    return { allLocationIds, localLocations, setLocalLocations };
};
